<template>
  <div class="health-card-list">
    <div class="health-card-thumbnail">
      <div
        class="thumbnail-item"
        :class="current === index ? 'item-selected' : ''"
        v-for="(item, index) in healthCardList"
        :key="index"
        @click="goto(index)"
      >
        <img
          class="default-icon"
          src="../../../static/img/home/default_person_selected.png"
          v-if="current === index"
        />
        <img
          class="default-icon"
          src="../../../static/img/home/default_person.png"
          v-else
        />
        <div class="name">{{ item.holderName }}</div>
        <img
          v-if="current === index"
          class="down-icon"
          src="../../../static/img/home/down_selected_icon.png"
        />
      </div>
      <div
        class="thumbnail-item"
        :class="current === healthCardList.length ? 'item-selected' : ''"
        @click="goto(healthCardList.length)"
        v-if="healthCardList.length < 3"
      >
        <img
          v-if="current === healthCardList.length"
          class="default-icon"
          src="../../../static/img/home/card_add_active.png"
        />
        <img
          v-else
          class="default-icon card-add"
          src="../../../static/img/home/card_add_unselected.png"
        />
        <div class="name"></div>
        <img
          v-if="current === healthCardList.length"
          class="down-icon mt"
          src="../../../static/img/home/down_selected_icon.png"
        />
      </div>
    </div>
    <div class="swiper">
      <swiper :options="swiperOption" ref="mySwiper" @slideChange="slideChange">
        <swiper-slide
          v-for="(item, index) in healthCardList"
          :key="index"
          class="card"
        >
          <div @click="selectVoucher(item)">
            <health-card :data="item"></health-card>
          </div>
        </swiper-slide>
        <swiper-slide v-if="healthCardList.length < 3">
          <img
            src="../../../static/img/home/health_card_add.png"
            class="card-add"
            @click="goAddVoucher"
          />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import Qrcode from 'v-qrcode'
import { swiper, swiperSlide } from "vue-awesome-swiper"
import "swiper/dist/css/swiper.css"
import HealthCard from './health-card.vue'
export default {
  components: {
    Qrcode,
    swiper,
    swiperSlide,
    HealthCard
  },
  props: {
    healthCardList: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      current: 0,
      swiperOption: {
      }
    }
  },
  methods: {
    goto (index) {
      this.current = index
      this.$refs.mySwiper.swiper.slideTo(index)
    },
    slideChange () {
      this.current = this.$refs.mySwiper.swiper.activeIndex
    },
    selectVoucher (voucher) {
      this.$store.commit('updateParam', {
        namespace: 'detail',
        voucher: voucher
      });
      this.$router.push('voucherDetail');
    },
    goAddVoucher () {
      this.$router.push({
        path: 'voucherChooseType'
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.health-card-list {
  background: #fff;
  border-radius: 10px;
  padding: 10px 0;

  .health-card-thumbnail {
    display: flex;
    padding: 0;
    margin: 0 5%;
    overflow: hidden;

    .thumbnail-item {
      text-align: center;
      margin-right: 15px;
      .default-icon {
        width: 24px;
        height: 24px;
        display: block;
        margin: 5px auto 5px auto;
      }

      .card-add {
        margin-top: 5px;
      }

      .name {
        font-size: 10px;
        color: #999;
      }
    }

    .item-selected {
      .default-icon {
        width: 34px;
        height: 34px;
        display: block;
        margin: 0 auto;
      }
      .name {
        font-size: 12px;
        color: #1daf57;
      }

      .down-icon {
        width: 8px;
        height: 8px;
        display: block;
        margin: 0 auto;
      }
      .mt {
        margin-top: 16px;
      }
    }
  }
}

.swiper {
  margin-top: 10px;
  .swiper-container {
    position: relative;
    height: 4.8rem;

    .swiper-slide {
      width: 90% !important;
      margin: 0 5%;
      height: 4.8rem;
      color: #333;
      .card-add {
        width: 100%;
        height: 100%;
      }
    }
    .swiper-slide-prev {
      right: -8%;
    }
    .swiper-slide-next {
      left: -8%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// swiper.vue?4c32aa3a